// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bread_crumbs-module__breadcrumbs___nwR9t{display:inline-flex}
`, "",{"version":3,"sources":["webpack://./src/components/BreadCrumbs/bread_crumbs.module.scss"],"names":[],"mappings":"AAAA,0CACI,mBAAoB","sourcesContent":[".breadcrumbs {\n    display: inline-flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs": `bread_crumbs-module__breadcrumbs___nwR9t`
};
export default ___CSS_LOADER_EXPORT___;
